import {
  injectGlobal
}
from 'styled-components';

import SimplonRegularTTF from "../assets/SimplonMono-Regular-WebS.ttf";
import SimplonRegularWOFF from "../assets/SimplonMono-Regular-WebS.woff";

export default injectGlobal `
  @font-face {
    font-family: "Simplon-Regular";
    font-style: normal;
    font-weight: normal;
    src: local("Simplon Regular"), local("Simplon-Regular"), url(${SimplonRegularTTF}) format("ttf"), url(${SimplonRegularWOFF}) format("woff");
  }
`


// WEBPACK FOOTER //
// ./src/layouts/fonts.js